import { useCallback, useEffect, useRef } from "react";
import {
  clearGoalActivationContinuation,
  readGoalActivationContinuation,
  resumeGoalActivationCheckout,
} from "./goalActivationContinuation";

export function useGoalActivationCheckoutReturn(
  ownerId: string,
  payment: string | null,
  replace: (href: string) => void,
) {
  const handled = useRef<string | undefined>(undefined);
  const resume = useCallback(() => {
    const pending = readGoalActivationContinuation(ownerId);
    if (!pending) {
      return false;
    }
    if (handled.current === pending.idempotencyKey) {
      return true;
    }
    handled.current = pending.idempotencyKey;
    return resumeGoalActivationCheckout(ownerId, replace);
  }, [ownerId, replace]);

  useEffect(() => {
    if (payment === "cancel") {
      clearGoalActivationContinuation(ownerId);
    } else if (
      readGoalActivationContinuation(ownerId)?.phase === "activating"
    ) {
      resume();
    }
  }, [ownerId, payment, resume]);
  return resume;
}
